<template>
  <div>
    <el-form :rules="rules" ref="userForm" :model="form" label-position="top">
      <el-form-item :label="$t('addUserForm.firstnameLabel')" prop="firstname">
        <el-input
          :disabled="!firstnameEditable"
          data-test="profile-input__firstname"
          :placeholder="$t('addUserForm.firstnameLabel')"
          v-model="form.firstname">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addUserForm.lastnameLabel')" prop="lastname">
        <el-input
          :disabled="!lastnameEditable"
          data-test="profile-input__lastname"
          :placeholder="$t('addUserForm.lastnameLabel')"
          v-model="form.lastname">
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="roleEditable"
        data-test="profile__role-select"
        :label="$t('addUserForm.chooseRoleLabel')" prop="role">
        <el-select
          style="width: 100%"
          v-model="form.role"
          :placeholder="$t('addUserForm.chooseRoleLabel')"
          data-test="profile-input__role">
          <el-option
            v-for="role in rolesList"
            :key="role.label"
            :label="role.label"
            :value="role.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          class="update__button"
          data-test="save-button"
          type="primary" @click="onSave">
          {{ saveButtonText }}
        </el-button>
        <el-button
          class="cancel__button"
          v-if="cancelable"
          data-test="cancel-button"
          @click="$emit('canceled')">
          {{ cancelButtonText }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  props: {
    saveButtonText: { type: String },
    userProfile: { type: Object, default: () => ({}) },
    cancelable: { type: Boolean, default: false },
    cancelButtonText: { type: String, default: 'Annuler' },
    roleEditable: { type: Boolean, default: false },
    titleEditable: { type: Boolean, default: false },
    firstnameEditable: { type: Boolean, default: true },
    lastnameEditable: { type: Boolean, default: true },
  },
  data() {
    return {
      form: {
        firstname: this.userProfile.firstname || '',
        lastname: this.userProfile.lastname || '',
        role: this.userProfile.role || '',
      },
    };
  },
  methods: {
    onSave() {
      const userProfile = this.form;
      this.$refs.userForm.validate((valid) => {
        if (!valid) { return; }
        this.$emit('onSave', userProfile);
      });
    },
  },
  computed: {
    rules() {
      return {
        lastname: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
        ],
        firstname: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
        ],
        role: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
        ],
      };
    },
    rolesList() {
      const roles = this.$store.getters['permissions/rolesList'];
      return roles.map((role) => ({
        label: this.$t(`roles.${role}`),
        value: role,
      }));
    },
  },
};
</script>
<style lang="stylus" scoped>
.update__button, .cancel__button {
  width: 100%;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}
// iPad Portrait
@media only screen and (min-width: 48rem) {
}
//iPad Landscape + desktop
@media only screen and (min-width: 64rem) {
  .update__button, .cancel__button {
    width: auto;
  }
  .cancel__button {
    margin-left: 10px;
  }
}
//Desktop petit + hd desktop
@media only screen and (min-width: 80rem) {
}
</style>
